module.exports = __webpack_public_path__ + "img/people.665094ec.svg";